/* eslint-disable @typescript-eslint/interface-name-prefix */
export interface ILog {
  // info: Function
  // debug: Function
  // warn: Function
  // error: Function
  fps: Function;
}

export enum Level {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  FATAL = 'fatal',
  DEBUG = 'debug'
}

export interface ITags {
  [index: string]: string;
}

export interface IExtra {
  [index: string]: any;
}

export enum SentryLogTitle {
  Block = '页面卡顿'
}
